<div class="h-100 center">
  <div class="text-center">
    <mat-spinner></mat-spinner>
    <h6 class="mt-4">Loading...</h6>
  </div>
</div>
